import React from 'react';
import useReveal from '../../hooks/useReveal';
import { portfolioData } from '../../data/portfolioData';

export default function About() {
  const { about, stats, education, certifications, awards, interests } = portfolioData;
  const [ref, shown] = useReveal();

  return (
    <section className="section" id="about" ref={ref}>
      <div className={`reveal ${shown ? 'in' : ''}`}>
        <span className="eyebrow">01 — Who I am</span>
        <h2 className="section-title">
          Automating the <span className="cyan-text">boring</span>,
          <br />
          <span className="outline-text">shipping the rest.</span>
        </h2>
      </div>

      <div className="about-grid">
        <div className={`about-bio reveal ${shown ? 'in' : ''}`}>
          {about.bio.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
          <div className="chip-row">
            {about.professional.map((p) => (
              <span className="chip" key={p}>
                {p}
              </span>
            ))}
            {interests.map((p) => (
              <span className="chip" key={p}>
                {p}
              </span>
            ))}
          </div>
        </div>

        <div className={`about-side reveal ${shown ? 'in' : ''}`}>
          <div className="side-label">Certifications</div>
          {certifications.map((c) => (
            <div className="cert-item" key={c.title}>
              <div className="cert-badge">AWS</div>
              <div>
                <div className="cert-title">{c.title}</div>
                <div className="cert-meta">
                  {c.issuer} · {c.date}
                </div>
              </div>
            </div>
          ))}

          <div className="side-label">Education</div>
          {education.map((e) => (
            <div className="edu-item" key={e.degree}>
              <div className="edu-degree">{e.degree}</div>
              <div className="edu-meta">
                <span>{e.school}</span>
                <span>{e.period}</span>
              </div>
            </div>
          ))}

          <div className="side-label">Honours</div>
          {awards.map((a) => (
            <div className="edu-item" key={a.title}>
              <div className="edu-degree">{a.title}</div>
              <div className="edu-meta">
                <span>{a.org}</span>
                <span>{a.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={`stats reveal ${shown ? 'in' : ''}`} style={{ marginTop: '3.5rem' }}>
        {stats.map((s) => (
          <div className="stat" key={s.label}>
            <div className="stat-value">{s.value}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
